var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { ExploreService } from 'src/app/explore/explore.service';
import { StoryState } from 'src/app/story/state/story.state';
import { StoryService } from 'src/app/story/story.service';
import { ActivatedRoute } from '@angular/router';
export class ViewInternalHeaderComponent {
    // ---------- Lifecycle ----------
    constructor(activatedRoute, store, changeDetectorRef, exploreService, storyService) {
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.exploreService = exploreService;
        this.storyService = storyService;
        // ---------- Class Variables ---------- 
        this.ngUnsubscribe = new Subject();
        this.id = '';
        this.type = '';
        this.category = '';
    }
    ngOnInit() {
        this.story$
            .pipe(filter(story => story != null), takeUntil(this.ngUnsubscribe))
            .subscribe(story => {
            this.id = this.activatedRoute.snapshot.queryParams.id;
            this.type = this.storyService.getStoryType(this.activatedRoute.snapshot.queryParams.id);
            this.category = this.exploreService.getStoryCategory(story);
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    get bookmarkActions() {
        const organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        return [
            BookmarkActionsEnum.CopyLink,
            BookmarkActionsEnum.Embed,
            BookmarkActionsEnum.CopyBookmark,
            // add optional organization actions
            ...organization ? [BookmarkActionsEnum.CopyTeamBookmark] : []
        ];
    }
}
__decorate([
    Select(StoryState.getStory),
    __metadata("design:type", Observable)
], ViewInternalHeaderComponent.prototype, "story$", void 0);
